var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        class:
          "menubuilder__logo " +
          (_vm.logo.data == "" && "menubuilder__logo--empty")
      },
      [
        _vm.logo.data === ""
          ? _c("span", [
              _vm._v("\n      Your logo "),
              _c("br"),
              _vm._v(" goes here\n    ")
            ])
          : _c(
              "div",
              { staticClass: "menubuilder__logo menubuilder__logo--full" },
              [
                _c("img", { attrs: { src: _vm.logo.data, alt: "" } }),
                _vm._v(" "),
                _c("span", { on: { click: _vm.clearLogo } }, [_vm._v("×")])
              ]
            )
      ]
    ),
    _vm._v(" "),
    _c("input", {
      staticClass: "menubuilder__logoupload",
      attrs: {
        type: "file",
        accept: ".png, .jpg, .jpeg",
        name: "logo",
        id: "logo"
      },
      on: {
        change: function($event) {
          return _vm.updatePreview($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "menubuilder__button", on: { click: _vm.uploadFile } },
      [_vm._v("\n    Upload a logo\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/MenuBuilder/LogoUpload.vue?vue&type=template&id=166dddb4&
// module id = 121
// module chunks = 3